__turbopack_context__.v({
  "caret": "ai-chat-visual-module__b0JoJq__caret",
  "caretBlink": "ai-chat-visual-module__b0JoJq__caretBlink",
  "input": "ai-chat-visual-module__b0JoJq__input",
  "inputFilled": "ai-chat-visual-module__b0JoJq__inputFilled",
  "resultRow": "ai-chat-visual-module__b0JoJq__resultRow",
  "results": "ai-chat-visual-module__b0JoJq__results",
  "rise": "ai-chat-visual-module__b0JoJq__rise",
  "riseIn": "ai-chat-visual-module__b0JoJq__riseIn",
  "riseInner": "ai-chat-visual-module__b0JoJq__riseInner",
  "send": "ai-chat-visual-module__b0JoJq__send",
  "sendArmed": "ai-chat-visual-module__b0JoJq__sendArmed",
});
